module.exports = __webpack_public_path__ + "img/logo4.67899c80.png";